export interface OnboardingStep {
  id: string;
  stepNumber: number;
  title: string;
  description: string;
  targetSelector: string; // CSS selector of the sidebar element to highlight
  route?: string;          // Route to navigate to when this step is active
  tooltipPosition: 'right' | 'bottom' | 'top' | 'left';
  expandMenu?: string;     // Feature ID of the parent submenu to expand
}

export const ONBOARDING_TOTAL_STEPS = 13;

export const onboardingSteps: OnboardingStep[] = [
  {
    id: 'welcome',
    stepNumber: 1,
    title: 'Selamat datang di Chatshop!',
    description:
      'Yuk kenalan singkat dengan menu-menu utama supaya toko Anda siap jualan. Cuma butuh waktu sebentar.',
    targetSelector: '[data-tour="nav-merchant-profile"]',
    route: '/',
    tooltipPosition: 'right',
  },
  {
    id: 'setting-profile',
    stepNumber: 2,
    title: '1. Lengkapi profil toko',
    description:
      'Mulai dari sini. Isi nama toko, logo, dan kontak agar pelanggan lebih percaya belanja di toko Anda.',
    targetSelector: '[data-tour="nav-settingprofil"]',
    route: '/setting/profile',
    tooltipPosition: 'right',
    expandMenu: 'setting',
  },
  {
    id: 'setting-delivery',
    stepNumber: 3,
    title: '2. Atur pengiriman',
    description:
      'Pilih kurir dan wilayah yang dilayani. Setelah diatur, ongkos kirim otomatis muncul saat pelanggan checkout.',
    targetSelector: '[data-tour="nav-settingdelivery"]',
    route: '/setting/delivery',
    tooltipPosition: 'right',
    expandMenu: 'setting',
  },
  {
    id: 'setting-business-days',
    stepNumber: 4,
    title: '3. Atur jam buka toko',
    description:
      'Tentukan jam operasional toko supaya pelanggan tahu kapan pesanan bisa diproses.',
    targetSelector: '[data-tour="nav-settingbusinessday"]',
    route: '/setting/business-days',
    tooltipPosition: 'right',
    expandMenu: 'setting',
  },
  {
    id: 'products',
    stepNumber: 5,
    title: '4. Tambah produk',
    description:
      'Di sini Anda menambahkan produk, barang, atau layanan yang akan dijual.',
    targetSelector: '[data-tour="nav-listproducts"]',
    route: '/products',
    tooltipPosition: 'right',
    expandMenu: 'product',
  },
  {
    id: 'categories',
    stepNumber: 6,
    title: '5. Buat kategori & merek',
    description:
      'Kelompokkan produk berdasarkan kategori dan merek agar pelanggan lebih mudah mencari.',
    targetSelector: '[data-tour="nav-category"]',
    route: '/categories',
    tooltipPosition: 'right',
    expandMenu: 'product',
  },
  {
    id: 'ai-studio',
    stepNumber: 7,
    title: '6. Coba AI Product Studio',
    description:
      'Gunakan AI untuk membantu membuat deskripsi atau foto produk secara otomatis.',
    targetSelector: '[data-tour="nav-aistudio"]',
    tooltipPosition: 'right',
    expandMenu: 'product',
  },
  {
    id: 'orders-new',
    stepNumber: 8,
    title: '7. Kelola pesanan masuk',
    description:
      'Pesanan baru dari pelanggan akan muncul di sini, lalu bergerak ke Proses hingga Selesai.',
    targetSelector: '[data-tour="nav-neworder"]',
    route: '/orders/new',
    tooltipPosition: 'right',
    expandMenu: 'order',
  },
  {
    id: 'customers',
    stepNumber: 9,
    title: '8. Lihat data pelanggan',
    description:
      'Pantau daftar pelanggan dan reseller yang sudah pernah bertransaksi di toko Anda.',
    targetSelector: '[data-tour="nav-customers"]',
    route: '/customers',
    tooltipPosition: 'right',
    expandMenu: 'reseller',
  },
  {
    id: 'finance-bank',
    stepNumber: 10,
    title: '9. Daftarkan rekening bank',
    description:
      'Tambahkan rekening bank untuk proses penarikan saldo hasil penjualan Anda.',
    targetSelector: '[data-tour="nav-bank"]',
    route: '/finance/bank',
    tooltipPosition: 'right',
    expandMenu: 'finance',
  },
  {
    id: 'finance-withdraw',
    stepNumber: 11,
    title: '10. Penarikan saldo',
    description:
      'Ajukan penarikan saldo kapan saja setelah transaksi berhasil dan saldo tersedia.',
    targetSelector: '[data-tour="nav-withdraw"]',
    route: '/finance/withdraw',
    tooltipPosition: 'right',
    expandMenu: 'finance',
  },
  {
    id: 'report-order',
    stepNumber: 12,
    title: '11. Laporan penjualan',
    description:
      'Lihat rekap penjualan harian, mingguan, atau bulanan untuk memantau performa toko.',
    targetSelector: '[data-tour="nav-reportorder"]',
    route: '/report/order',
    tooltipPosition: 'right',
    expandMenu: 'report',
  },
  {
    id: 'chat-history',
    stepNumber: 13,
    title: '12. Pantau chat pelanggan',
    description:
      'Lihat riwayat percakapan WhatsApp dengan pelanggan untuk memastikan layanan berjalan baik.',
    targetSelector: '[data-tour="nav-chat-history"]',
    route: '/chat-history',
    tooltipPosition: 'right',
  },
];
